import { render, staticRenderFns } from "./WorkTile.vue?vue&type=template&id=1a50a3b5&scoped=true&"
import script from "./WorkTile.vue?vue&type=script&lang=js&"
export * from "./WorkTile.vue?vue&type=script&lang=js&"
import style0 from "./WorkTile.vue?vue&type=style&index=0&id=1a50a3b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a50a3b5",
  null
  
)

export default component.exports